/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  lazy, useEffect, useState
} from 'react';
import { v4 as uuid } from 'uuid';
import { PanelDisplayState } from 'utility/enumerations';
import { useHistory } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Section from 'components/shared/form/section';
import { mediaQueryKeys } from 'utility/constants';
import { useBreakpoint } from 'components/shared/context/breakpoint_provider';

const getDisplayModeClass = (displayMode) => {
  switch (displayMode) {
    case PanelDisplayState.OneThird:
      return 'one-third';
    case PanelDisplayState.TwoThird:
      return 'two-third';
    case PanelDisplayState.Full:
      return 'full';
    case PanelDisplayState.None:
      return 'd-none';
    default:
      return '';
  }
};

const importView = (viewPath) => lazy(() => import(`./${viewPath}`).catch(() => import('./null_view')));

interface DynamicProps {
  viewToShow: any,
  scrollTo: any,
  className: any,
  displayMode: any
}

export const Dynamic = React.forwardRef((props: DynamicProps, ref) => {
  const [view, setView] = useState([]) as any;
  const breakpoints = useBreakpoint();
  const history = useHistory();

  useEffect(() => {
    const {
      viewPath = 'null_view', viewProps, focusView, overrideLocation, params = {}
    } = props.viewToShow;
    if (overrideLocation) {
      history.push(overrideLocation);
    }

    async function loadView() {
      const componentPromise = async () => {
        const View = await importView(viewPath);
        return (
          <View
            key={uuid()}
            history={history}
            {...viewProps}
            scrollTo={focusView && breakpoints[mediaQueryKeys.mdDown] ? props.scrollTo : null}
            params={params}
          />
        );
      };

      componentPromise().then(setView);
    }

    loadView();
  }, [props.viewToShow]);

  return view ? (
    <React.Suspense
      fallback={(
        <div className={`${props.className || ''} ${getDisplayModeClass(props.displayMode)}`}>
          <Container />
        </div>
              )}
    >
      <div className={`${props.className || ''} ${getDisplayModeClass(props.displayMode)}`}>
        <Section ref={ref} id={`${props.viewToShow.viewPath}-${uuid()}`}>
          <Container fluid>{view}</Container>
        </Section>
      </div>
    </React.Suspense>
  ) : (
    null
  );
});
